import useGlobalConfig from '@/store/global';

const Nuwiq = () => {
  const { themeColor } = useGlobalConfig();
  return (
    <>
      <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
        <div className="my-6 border-b-2 border-dotted" style={{ borderColor: themeColor }} />

        <div className="font-bold text-base" style={{ color: themeColor }}>
          Indications and Important Safety Information for NUWIQ [Antihemophilic Factor
          (Recombinant)]
        </div>

        <p className="mt-2 font-bold">
          Please see NUWIQ&nbsp;
          <a
            target="_blank"
            href="/nuwiq-full-prescribing-information.pdf"
            className="underline"
            rel="noopener noreferrer"
          >
            full Prescribing Information
          </a>
          .&nbsp;
          <a
            target="_blank"
            href="/nuwiq-instructions-for-use.pdf"
            className="underline"
            rel="noopener noreferrer"
          >
            Instructions For Use
          </a>
          .
        </p>

        <div className="mt-6">
          <p className="my-2 font-bold">Indications and Use</p>
          <p className="my-2">
            NUWIQ® is a recombinant antihemophilic factor [coagulation factor VIII (Factor VIII)]
            indicated in adults and children with Hemophilia A for On-demand treatment and control
            of bleeding episodes, perioperative management of bleeding, routine prophylaxis to
            reduce the frequency of bleeding episodes. NUWIQ® is not indicated for the treatment of
            von Willebrand Disease.
          </p>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Contraindications</p>
          <p className="my-2">
            NUWIQ is contraindicated in patients who have manifested life-threatening
            hypersensitivity reactions, including anaphylaxis, to the product or its components.
          </p>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Warnings and Precautions</p>
          <ul>
            <li className="my-2">
              Hypersensitivity reactions, including anaphylaxis, are possible with NUWIQ. Early
              signs of hypersensitivity reactions that can progress to anaphylaxis may include
              angioedema, chest tightness, dyspnea, wheezing, urticaria, or pruritus. Immediately
              discontinue administration and initiate appropriate treatment if hypersensitivity
              reactions occur.
            </li>
            <li className="my-2">
              The formation of neutralizing antibodies (inhibitors) to Factor VIII can occur
              following the administration of NUWIQ. Monitor all patients for the development of
              Factor VIII inhibitors by appropriate clinical observations and laboratory tests. If
              the plasma Factor VIII level fails to increase as expected, or if bleeding is not
              controlled after NUWIQ administration, suspect the presence of an inhibitor
              (neutralizing antibody).
            </li>
          </ul>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Adverse Reactions</p>
          <p className="my-2">
            The most frequently occurring adverse reactions (&gt;5%) in clinical trials were upper
            respiratory tract infection, headache, fever, cough, lower respiratory tract infection,
            rhinitis, chills, abdominal pain, arthralgia, anemia, and pharyngitis.
          </p>
        </div>

        <div className="mt-6">
          <p className="my-2">
            Please click here for&nbsp;
            <a
              target="_blank"
              href="/nuwiq-full-prescribing-information.pdf"
              className="!text-sky-700 hover:underline"
              rel="noopener noreferrer"
            >
              Full Prescribing Information.
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default Nuwiq;
